import React, {FC} from 'react';
import {useHyperlinkCmp} from './hooks/useHyperlinkCmp';
import {SideBarContent} from '../../SideBarContent';

export const HyperlinkCmp: FC = () => {
    const {renderBody, renderFooter, renderHeader} = useHyperlinkCmp();

    return <SideBarContent {...{renderHeader, renderBody, renderFooter}} />;
};
